import React from 'react';
import styled from 'styled-components';
import { animated, useSpring } from '@react-spring/web';
import cx from 'classnames';
import { useTheme } from '../theme/theme-context';
const StyledProgressBar = styled.svg `
  background-color: var(--bg-color-1);
  height: 6px;
  border-radius: 3px;
  width: 150px;

  [data-role='indicator'] {
    background-color: var(--primary);
    height: 6px;
    border-radius: 3px;
  }
`;
const WIDTH = 150;
export const ProgressBar = (props) => {
    var _a;
    const width = props.value ? props.value : ((_a = props.percent) !== null && _a !== void 0 ? _a : 0) * WIDTH;
    const styles = useSpring({ width });
    const { theme } = useTheme();
    return (React.createElement(StyledProgressBar, { onClick: props.onClick, stroke: theme.color.bgColor1, viewBox: `0 0 ${WIDTH} 6`, xmlns: "http://www.w3.org/2000/svg", "data-role": "progress-bar", className: cx('progress-bar', props.className) },
        React.createElement(animated.line, { x1: "0", y1: "3", x2: styles.width, y2: "3", stroke: theme.color.primary, strokeWidth: 6, strokeLinecap: styles.width.to((x) => (x !== 0 ? 'round' : 'inherit')) })));
};
